import { call, all, put, takeLatest } from 'redux-saga/effects';
import notification from '../../../services/notification';
import api from '../../../services/api';
import types from '../../types';
import { modal } from '../../../components/Base/Modal';

function* getPairs() {
  try {
    const { status, data } = yield call(api.market.pairs.getPairs);
    if (status < 200 || status >= 300) throw new Error('Something went wrong');
    yield put({ type: types.GET_PAIRS_SUCCESS, payload: data });
  } catch (error) {
    yield put({ type: types.GET_PAIRS_FAILURE });
    if (error?.response?.status === 401) return;
    notification({ type: 'error', message: 'Error. Please try again later.' });
  }
}

function* updatePairs({ payload }) {
  try {
    const { status, data } = yield call(api.market.pairs.updatePairs, payload);
    if (status < 200 || status >= 300) throw new Error('Something went wrong');
    yield put({ type: types.UPDATE_PAIRS_SUCCESS, payload: data });
    yield put({ type: types.GET_PAIRS_START });
  } catch (error) {
    yield put({ type: types.UPDATE_PAIRS_FAILURE });
    if (error?.response?.status === 401) return;
    notification({ type: 'error', message: 'Error. Please try again later.' });
  }
}

function* updateTopPairs({ payload }) {
  try {
    const { status, data } = yield call(api.market.pairs.updateTopPairs, payload);
    if (status < 200 || status >= 300) throw new Error('Something went wrong');
    yield put({ type: types.UPDATE_TOP_PAIRS_SUCCESS, payload: data });
    yield put({ type: types.GET_PAIRS_START });
  } catch (error) {
    yield put({ type: types.UPDATE_TOP_PAIRS_FAILURE });
    if (error?.response?.status === 401) return;
    notification({ type: 'error', message: 'Error. Please try again later.' });
  }
}

function* postPairs({ payload }) {
  try {
    const { status, data } = yield call(api.market.pairs.postPair, payload);
    if (status < 200 || status >= 300) throw new Error('Something went wrong');
    yield put({ type: types.POST_PAIRS_SUCCESS, payload: data });
    yield put({ type: types.GET_PAIRS_START });
    modal.close();
  } catch (error) {
    yield put({ type: types.POST_PAIRS_FAILURE });
    if (error?.response?.status === 401) return;
    notification({
      type: 'error',
      message: error?.response?.data
        ? error?.response?.data.replace(/_/g, ' ')
        : 'Error. Please try again later.',
    });
  }
}

export function* pairs() {
  yield all([
    takeLatest(types.GET_PAIRS_START, getPairs),
    takeLatest(types.UPDATE_PAIRS_START, updatePairs),
    takeLatest(types.UPDATE_TOP_PAIRS_START, updateTopPairs),
    takeLatest(types.POST_PAIRS_START, postPairs),
  ]);
}
